/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, EventEmitter, input, Input, Output } from '@angular/core';
import { BpSelectableContact } from '../bp-selectable-contact.model';

@Component({
  selector: 'well-bp-selectable-contact-card',
  templateUrl: './bp-selectable-contact-card.component.html',
  styleUrls: ['./bp-selectable-contact-card.component.scss'],
})
export class BpSelectableContactCardComponent {
  @Input() bpContact: BpSelectableContact | undefined = undefined;

  @Input() readOnly = true;
  @Input() showCompanyForContact = false;

  displayCheckbox = input(true);
  isPublic = input<boolean | undefined>(undefined);

  @Output() bpChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  onChange(event: any) {
    const checkboxValue = event.checked;
    this.bpChange.emit(checkboxValue);
  }
}
